import React from "react";

import { Box, IconButton, Typography, Modal, Backdrop, } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import { makeStyles } from "@mui/styles";
import { useSpring, animated } from "@react-spring/web";
import PropTypes from "prop-types";

const Fade = React.forwardRef(function Fade(props, ref) {
  const {
    children,
    in: open,
    onClick,
    onEnter,
    onExited,
    ownerState,
    ...other
  } = props;
  const style = useSpring({
    from: { opacity: 0 },
    to: { opacity: open ? 1 : 0 },
    onStart: () => {
      if (open && onEnter) {
        onEnter(null, true);
      }
    },
    onRest: () => {
      if (!open && onExited) {
        onExited(null, true);
      }
    },
  });

  return (

    <animated.div ref={ref} style={style} {...other}>
      {React.cloneElement(children, { onClick })}
    </animated.div>
  );
});

Fade.propTypes = {
  children: PropTypes.element.isRequired,
  in: PropTypes.bool,
  onClick: PropTypes.any,
  onEnter: PropTypes.func,
  onExited: PropTypes.func,
  ownerState: PropTypes.any,
};

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  backdrop: {
    transition: "0.1s all linear",
    backdropFilter: "blur(1px)",
    backgroundColor: "#ffffff",
  },
}));

const CustomModal = ({ open, onClose, children, title, width }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width,
    bgcolor: "background.paper",
    boxShadow: 24,
    boxSizing: "border-box",
    borderRadius: 4,
    maxHeight: "70vh",
    overflowY: "scroll",
  };
  const classes = useStyles();

  return (
    <Modal
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      open={open}
      onClose={onClose}
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          TransitionComponent: Fade,
        },
      }}
      BackdropProps={{
        className: classes.backdrop,
      }}
    >
      <Fade in={open}>
        <Box sx={style} className="hide_scrollbar">
          <Box
            sx={{
              borderRadius: "5px 5px 0px 0px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              bgcolor: "background.card",
              
              p: 2,
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <Typography
              sx={{ fontSize: "16px", fontWeight: 700, color:'#000' }}
            >
              {title}
            </Typography>
            <IconButton onClick={onClose}>
              <IoMdClose style={{ fontSize: "20px" }} />
            </IconButton>
          </Box>

          {children}
        </Box>
      </Fade>
    </Modal>
  );
};

export default CustomModal;
